import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Spinner } from 'reactstrap';
import { toast } from "react-toastify";
import ParticlesAuth from "./ParticlesAuth";

import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import { hasRememberedIdentity } from "../../helpers/rememberedIdentity";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useAuthStore } from "../../stores/useAuthStore";
import logoAgerouteLight from "../../assets/images/logo-ageroute-light.png";
import logoAgerouteDark from "../../assets/images/logo-ageroute-dark.png";

const LoginAlerte = (props: any) => {
    const navigate = useNavigate();
    const { user, error, errorMsg, loginUser, resetLoginFlag, loading } = useAuthStore();

    const [userLogin, setUserLogin] = useState<any>([]);
    const [passwordShow, setPasswordShow] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(false);
    const [rememberMe, setRememberMe] = useState<boolean>(false);

    useEffect(() => {
        if (user && Object.keys(user).length) {
            setUserLogin({
                username: user.username,
                password: user.confirm_password || user.password || ""
            });
        }
    }, [user]);

    useEffect(() => {
        if (!user?.token && hasRememberedIdentity()) {
            navigate("/welcome-back", { replace: true });
        }
    }, [user?.token, navigate]);

    const validation: any = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            username: userLogin.username || "",
            password: userLogin.password || "",
        },
        validationSchema: Yup.object({
            username: Yup.string().required("Veuillez entrer votre nom d'utilisateur"),
            password: Yup.string().required("Veuillez entrer votre mot de passe"),
        }),
        onSubmit: (values) => {
            loginUser(
                { username: values.username, password: values.password },
                props.router.navigate,
                { rememberMe }
            );
            setLoader(true);
        }
    });

    useEffect(() => {
        if (error && errorMsg) {
            toast.error(error);
            const t = setTimeout(() => {
                resetLoginFlag();
                setLoader(false);
            }, 3000);
            return () => clearTimeout(t);
        }
    }, [error, errorMsg, resetLoginFlag]);

    useEffect(() => {
        if (loading === false && loader) {
            setLoader(false);
        }
    }, [loading, loader]);

    document.title = "Connexion | Road Alert AGEROUTE";
    
    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 mb-4 text-white-50">
                                    <div className="d-inline-block position-relative">
                                        <Link to="/" className="auth-logo">
                                            <img src={logoAgerouteLight} alt="AGEROUTE" height="50" className="logo-img-light" />
                                            <img src={logoAgerouteDark} alt="AGEROUTE" height="50" className="logo-img-dark position-absolute top-0 start-0" />
                                        </Link>
                                    </div>
                                    <p className="mt-3 fs-15 fw-medium text-white">Plateforme d'Alerte Routière - AGEROUTE</p>
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-4 rounded-3 shadow-sm border-0">
                                    <CardBody className="p-4">
                                        <div className="text-center mt-2">
                                            <h5 className="text-primary">Bienvenue !</h5>
                                            <p className="text-muted">Connectez-vous pour accéder à Road Alert.</p>
                                        </div>
                                        <div className="p-2 mt-4">
                                            <Form
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}
                                                action="#">

                                                <div className="mb-3">
                                                    <Label htmlFor="username" className="form-label">Nom d'utilisateur</Label>
                                                    <Input
                                                        name="username"
                                                        id="username"
                                                        className="form-control"
                                                        placeholder="Entrez votre nom d'utilisateur"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.username || ""}
                                                        invalid={
                                                            validation.touched.username && validation.errors.username ? true : false
                                                        }
                                                    />
                                                    {validation.touched.username && validation.errors.username ? (
                                                        <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="mb-3">
                                                    <div className="float-end">
                                                        <Link to="/forgot-password" className="text-muted">Mot de passe oublié?</Link>
                                                    </div>
                                                    <Label className="form-label" htmlFor="password-input">Mot de passe</Label>
                                                    <div className="position-relative auth-pass-inputgroup mb-3">
                                                        <Input
                                                            name="password"
                                                            id="password-input"
                                                            value={validation.values.password || ""}
                                                            type={passwordShow ? "text" : "password"}
                                                            className="form-control pe-5"
                                                            placeholder="Entrez votre mot de passe"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={
                                                                validation.touched.password && validation.errors.password ? true : false
                                                            }
                                                        />
                                                        {validation.touched.password && validation.errors.password ? (
                                                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                        ) : null}
                                                        <button 
                                                            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" 
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                setPasswordShow(!passwordShow);
                                                            }} 
                                                            type="button" 
                                                            id="password-addon"
                                                        >
                                                            <i className="ri-eye-fill align-middle"></i>
                                                        </button>
                                                    </div>
                                                </div>

                                                <div className="form-check">
                                                    <Input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="auth-remember-check"
                                                        checked={rememberMe}
                                                        onChange={(e) => setRememberMe(e.target.checked)}
                                                    />
                                                    <Label className="form-check-label" htmlFor="auth-remember-check">
                                                        Se souvenir de moi (demander uniquement le mot de passe au retour)
                                                    </Label>
                                                </div>

                                                <div className="mt-4">
                                                    <Button 
                                                        color="primary"
                                                        disabled={loader}
                                                        className="btn btn-primary w-100" 
                                                        type="submit"
                                                        style={{ backgroundColor: '#311B91', borderColor: '#311B91' }}
                                                    >
                                                        {loader && <Spinner size="sm" className='me-2'> Loading... </Spinner>}
                                                        Se connecter
                                                    </Button>
                                                </div>
                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>

                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default withRouter(LoginAlerte);
